//imports
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VuePapaParse from "vue-papa-parse";

//Bootstrap-Vue
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

//Vue-use
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VuePapaParse);

//Vues
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
